import { useCreateSubCategoriMutation, useDeleteSubCategoriaMutation } from "src/gql/schema"
import { client } from "src/graphql"
import { ACTUALIZAR_CATEGORIA } from "src/pages/gastos/Gastos-Graphql/mutations/actualizar-categoria"
import HeaderIcon from "src/shared/components/data-display/header-icon/HeaderIcon"
import { Button } from "src/shared/components/forms"
import { Modal } from "src/shared/components/layout/modal/Modal"
import { MesajeEdit } from "./MesajeEdit"
export interface EditCategoriaGastosProps {
    id: string
    title: string
    onClose: () => void
    onConfirm: (error: boolean) => void
    resEdit: {
        limite: string | undefined
        gasto: string | undefined
    }
    dataAnterior: {
        gasto: string
        limiteA: string
    }
    newSubcategoryList: string[]
    deletedArray: string[]
    subCategorias: any[]
}
const EditCategoriaGastos = ({
    onClose,
    onConfirm,
    resEdit,
    title,
    dataAnterior,
    deletedArray,
    newSubcategoryList,
    id,
    subCategorias,
}: EditCategoriaGastosProps) => {
    const [deleteSubCategoriaMutation] = useDeleteSubCategoriaMutation()
    const [createSubCategoriMutation] = useCreateSubCategoriMutation()

    const sendCambios = async () => {
        const promises: Promise<boolean>[] = []
        if (newSubcategoryList.length !== 0) {
            for (const subcat of newSubcategoryList) {
                promises.push(createSubCategoriMutation({
                    variables: {
                        subCat: {
                            categoria_id: id,
                            subcategoria: subcat
                        }
                    },
                })
                    .then((data) => {
                        return true
                    })
                    .catch((err) => {
                        return false
                    }))
            }
        }
        if (deletedArray.length !== 0) {
            for (const subcatDeleted of deletedArray) {
                promises.push(deleteSubCategoriaMutation({
                    variables: {
                        id: {
                            subcategoria_gasto_id: subcatDeleted,
                        },
                    },
                })
                    .then((data) => {
                        return true
                    })
                    .catch((err) => {
                        return false
                    }))
            }
        }

        if (resEdit) {
            if (resEdit.limite) {
                const UpdateCategoriaGastosInput = {
                    categoria_id: id,
                    limite_mensual: Number(resEdit?.limite || 0),
                }
                try {
                    const { data } = await client.mutate({
                        mutation: ACTUALIZAR_CATEGORIA,
                        variables: { UpdateCategoriaGastosInput },
                    })
                    if (data) {
                        onConfirm(false)
                    }
                } catch (err) {
                    onConfirm(true)
                }
            }
        }

        const results = await Promise.all(promises)
        if (results.includes(false)) {
            onConfirm(true)
        } else {
            onConfirm(false)
        }

        onClose()
    }

    return (
        <Modal
            isOpen={true}
            withCloseButton
            onClose={() => onClose()}
            className="edit-categoria-modal"
            width={572}
            isCancelableOnClickOutside={false}
        >
            <HeaderIcon icon="editFill" title="¿Deseas guardar los cambios?" />
            <MesajeEdit newSubcategoryList={newSubcategoryList} resEdit={resEdit} dataAnterior={dataAnterior} deletedArray={deletedArray} subCategorias={subCategorias} />
            <Button text="Guardar Cambios" onClick={() => sendCambios()} style={{ width: "100%" }} />
        </Modal>
    )
}

export default EditCategoriaGastos
